import {useContext} from 'react';
import {useQuery} from '@tanstack/react-query';
import {Value} from 'patient-ping-remedy/packages/dropdown-list/lib/DropdownList';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {DropdownItemResponse, DropdownItemType} from '@/api/dto/dto';

// Labels start with the agency code, as in "AA001 - SELF"; agencies are listed by the name after it.
const agencyName = (agency: DropdownItemResponse) => agency.label.replace(/^.*? - /, '');

export const byAgencyName = (a: DropdownItemResponse, b: DropdownItemResponse) =>
  agencyName(a).localeCompare(agencyName(b));

export function useDeReferralAgencies() {
  const { carecoApi } = useContext(CarecoApiContext);

  const { data: agencies } = useQuery({
    queryKey: ['dropdownItems', [DropdownItemType.DE_REFERRAL_AGENCY]],
    queryFn: () => carecoApi?.getDropdownItems([DropdownItemType.DE_REFERRAL_AGENCY]),
    enabled: !!carecoApi,
  });

  const agencyOptions: Value[] = (agencies ?? [])
    .filter((agency) => agency.active)
    .sort(byAgencyName)
    .map((agency) => ({ label: agency.label, value: agency.value }));

  // A stored agency that is no longer active still shows, as its stored value.
  const toAgencyOption = (value?: string | null): Value | null => {
    if (!value) {
      return null;
    }
    return agencyOptions.find((option) => option.value === value) ?? { label: value, value };
  };

  return { agencyOptions, toAgencyOption };
}
